const PROPERTY_NAV_CACHE_KEY = 'zrm_property_nav_address';
const CREATE_LISTING_NAV_KEY = 'zrm_create_listing_is_new';

export type CachedPropertyAddress = {
  street: string;
  city: string;
  state: string;
  unit: string;
  zip: string;
};

export function cachePropertyAddress(address: CachedPropertyAddress): void {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.setItem(PROPERTY_NAV_CACHE_KEY, JSON.stringify(address));
  } catch {
    // Silently fail if sessionStorage is unavailable
  }
}

export function getCachedPropertyAddress(): CachedPropertyAddress | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(PROPERTY_NAV_CACHE_KEY);
    return raw ? (JSON.parse(raw) as CachedPropertyAddress) : null;
  } catch {
    return null;
  }
}

export function setIsNewListing(isNew: boolean): void {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.setItem(CREATE_LISTING_NAV_KEY, String(isNew));
  } catch {
    // Silently fail if sessionStorage unavailable
  }
}

export function getIsNewListing(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const value = sessionStorage.getItem(CREATE_LISTING_NAV_KEY);
    return value === 'true';
  } catch {
    // Silently fail
  }
  return false;
}

export function clearIsNewListing(): void {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.removeItem(CREATE_LISTING_NAV_KEY);
  } catch {
    // Silently fail
  }
}
